import CREATE_COMPANY_MUTATION from "../graphql/company/CreateCompany.gql";
import ACCOUNTING_COMPANY_OF_COMPANY from "../graphql/company/AccountingCompanyOfCompany.gql";
import ACCOUNTING_FIRM_CLIENT from "../graphql/billing/AccountingFirmClient.gql";

export function getSiretValue(siret: string) {
    if (!siret) {
        return "";
    }
    return siret.split("_")?.[0];
}

export async function createCompany(apollo, company, solution: any = "NO_SOLUTION") {
    let parentCompany;
    if (company.parentCompanyId) {
        parentCompany = { connect: { id: company.parentCompanyId } };
    } else if (company.parentCompany?.id) {
        parentCompany = { connect: { id: company.parentCompany.id } };
    }
    const result = await apollo.mutate({
        mutation: CREATE_COMPANY_MUTATION,
        variables: {
            name: company.name,
            shortName: company.shortName || "",
            legalUnitName: company.legalUnitName || undefined,
            tradeName: company.tradeName || undefined,
            siren: company.siren,
            siret: company.siret,
            vatNumber: company.vatNumber,
            address: company.address,
            postalCode: company.postalCode,
            city: company.city,
            country: company.country,
            registrationTown: company.registrationTown,
            shareCapital: company.shareCapital,
            activities: company.activities
                ? company.activities.map((a) => ({ name: a }))
                : undefined,
            parentCompany,
            profile: company.profile
                ? { zTillReceiptWithTransactions: true, ...company.profile }
                : undefined,
        },
    });
    if (result?.data?.createCompany) {
        return result.data.createCompany.id;
    }
    // debugger;
    return "";
}

export function defaultLegalForm(company) {
    let legalForm = "";
    if (company) {
        legalForm = company.name;
        if (company.shareCapital) {
            legalForm += " au capital social de " + company.shareCapital + " €";
        }
        let address = "";
        if (company.address) {
            address = company.address;
        }
        if (company.postalCode) {
            address += " " + company.postalCode;
        }
        if (company.city) {
            address += " " + company.city;
        }
        if (address) {
            legalForm += " - " + address;
        }
        if (company.registrationTown) {
            legalForm += " - RCS " + company.registrationTown;
            legalForm += " " + company.siren;
        }
        if (company.activities && company.activities.length) {
            legalForm += " - APE " + company.activities[0].name;
        }
        if (company.vatNumber) {
            legalForm += " - TVA Intracommunautaire " + company.vatNumber;
        }
    }
    return legalForm;
}

export async function getAccountingFirmFromUser(apollo, currentUser) {
    if (!currentUser) {
        return null;
    }
    // debugger;
    if (currentUser.company.siren !== "844122648") {
        const af = await getAccountingFirmFromCompany(apollo, currentUser.company.id);
        if (af) {
            return af;
        }
        if (currentUser.company.accountingFirm) {
            // if (isAccountingUser(currentUser)) {
            return currentUser.company;
        }
    }
    return null;
}

export async function getAccountingFirmFromCompany(apollo, companyId: string) {
    const result = await apollo.query({
        query: ACCOUNTING_COMPANY_OF_COMPANY,
        variables: {
            companyId,
        },
    });
    // debugger
    if (result.data && result.data.companies && result.data.companies.length) {
        const company = result.data.companies[0];
        return company;
    }
    return null;
}

export async function getAccountingFirmClient(apollo, accountingFirm, clientFirm) {
    if (!accountingFirm?.id || !clientFirm?.id) {
        return null;
    }
    const result = await apollo.query({
        query: ACCOUNTING_FIRM_CLIENT,
        variables: {
            accountingFirmId: accountingFirm.id,
            clientId: clientFirm.id,
        },
        fetchPolicy: "network-only",
    });
    return {
        offer: result.data?.accountingFirmClientFirst?.offer,
        accountManager: result.data?.accountingFirmClientFirst?.accountManager || null,
        accountingSignatory: result.data?.accountingFirmClientFirst?.accountingSignatory || null,
    };
}

export function isAccountingUser(user) {
    if (!user || !user.id || !user.profile) {
        return false;
    }

    if (user.profile.configuration.accounting.read) return true;
}

export * from "./other/time-zone";
